import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { h } from 'vue';

const emptyComponent = { render: () => h('span') };

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		component: emptyComponent,
	},
	{
		path: '/user',
		component: () => import(/* webpackChunkName: "user" */ '../views/user.vue'),
	},
	{
		path: '/:itemCategory',
		name: 'itemCategory',
		component: () =>
			import(/* webpackChunkName: "group" */ '../views/group.vue'),
		children: [
			{
				path: ':itemType',
				component: emptyComponent,
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
